export default "__VITE_ASSET__4781ed74__"